var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { PureComponent } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { bool, eventListener, object, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import './social-networks.css';
import { SocialNetworksApi } from './social-networks-api';
import { Link } from '@philips-internal/oswald-ui-components';
let SocialNetworks = class SocialNetworks extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            isDark: false
        };
    }
    static { this.propTypes = {
        data: object,
        isDark: bool,
        onSocialNetworkClick: eventListener,
        uuid: string,
    }; }
    static { this.defaultProps = {
        data: {},
        isDark: false
    }; }
    socialNetworkClick(link) {
        const { onSocialNetworkClick } = this.props;
        onSocialNetworkClick && onSocialNetworkClick({ value: link });
    }
    resolveLink(link) {
        if (link.indexOf('http') === -1) {
            link = `https://${link}`;
        }
        return link;
    }
    renderLogo(logoClass, logoType) {
        if (!logoType) {
            return null;
        }
        const link = this.resolveLink(logoType);
        const styles = this.props.isDark ? `${logoClass}-dark` : '';
        return (React.createElement("div", { className: "c-social-networks__logos" },
            React.createElement(Link, { onClick: () => this.socialNetworkClick(link), className: `c-social-networks-logo ${logoClass} ${styles}` })));
    }
    render() {
        const { data } = this.props;
        return (React.createElement("div", { className: "c-social-networks" },
            this.renderLogo('facebook-logo', data.dsLinkFacebook),
            this.renderLogo('instagram-logo', data.dsLinkInstagram),
            this.renderLogo('twitter-logo', data.dsLinkTwitter),
            this.renderLogo('youtube-logo', data.dsLinkYoutube),
            this.renderLogo('linkedin-logo', data.dsLinkLinkedin)));
    }
};
SocialNetworks = __decorate([
    AwesomeComponent({ api: SocialNetworksApi, type: ComponentType.DATA_DISPLAY })
], SocialNetworks);
export default SocialNetworks;
//# sourceMappingURL=social-networks.js.map